import type { Transaction } from "@rocicorp/zero";
import { type Context, userFacingError } from "../authorization";
import { type Schema, zql } from "../generatedDrizzleSchema";
import { hasAccess } from "../rbac/access";

// Changing whether a workflow’s live version is in operation — moving it out of
// its space, archiving, pausing, unpausing, or recovering it — is a
// publish-level act, so it takes the same permission as pushing live. Workflows
// with no live version stay at the caller’s space:write.
export async function assertCanChangeLiveness(
  tx: Pick<Transaction<Schema>, "run">,
  ctx: Context,
  workflow: { id: string; spaceId: string }
): Promise<void> {
  const [main] = await tx.run(
    zql.workflowBranches.where("workflowId", workflow.id).where("name", "main")
  );
  if (!main) return;
  const allowed = await hasAccess({
    tx,
    userId: ctx.userId,
    principal: ctx.principal,
    scopeId: workflow.spaceId,
    tenantId: ctx.tenantId,
    permission: "space:push_live",
  });
  if (!allowed) {
    throw userFacingError(
      "This workflow has a live version, so this action requires permission to push live"
    );
  }
}
